import type {
  EvidenceType,
  IncidentStatus,
  IncidentType,
  OrderStatus,
  SignatureType,
  StopStatus,
  StopType,
  TransferAssetStatus,
  TransferItemStatus,
} from '../../types/api';

/**
 * Textos y tonos del dominio logistico.
 *
 * Viven aparte de las pantallas porque los comparten tres vistas y porque
 * exportar constantes junto a un componente rompe el refresco en caliente.
 */
export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  DRAFT: 'Borrador',
  ASSIGNED: 'Confirmada',
  PENDING_PICKUP: 'Publicada',
  PICKUP_IN_PROGRESS: 'Cargando',
  AWAITING_SIGNATURE: 'Esperando firma',
  IN_TRANSIT: 'En ruta',
  DELIVERY_IN_PROGRESS: 'Entregando',
  DELIVERED: 'Entregada',
  COMPLETED: 'Cerrada',
  PARTIALLY_COMPLETED: 'Cerrada con faltantes',
  CANCELLED: 'Cancelada',
};

export type Tone = 'neutral' | 'success' | 'warning' | 'danger';

export const ORDER_STATUS_TONES: Record<OrderStatus, Tone> = {
  DRAFT: 'neutral',
  ASSIGNED: 'warning',
  PENDING_PICKUP: 'warning',
  PICKUP_IN_PROGRESS: 'warning',
  AWAITING_SIGNATURE: 'warning',
  IN_TRANSIT: 'warning',
  DELIVERY_IN_PROGRESS: 'warning',
  DELIVERED: 'success',
  COMPLETED: 'success',
  PARTIALLY_COMPLETED: 'warning',
  CANCELLED: 'danger',
};

export const STOP_TYPE_LABELS: Record<StopType, string> = {
  PICKUP: 'Recolección',
  DELIVERY: 'Entrega',
};

export const STOP_STATUS_LABELS: Record<StopStatus, string> = {
  PENDING: 'Pendiente',
  IN_PROGRESS: 'En proceso',
  AWAITING_SIGNATURE: 'Esperando firma',
  COMPLETED: 'Completada',
  SKIPPED: 'Omitida',
};

export const TRANSFER_ITEM_STATUS_LABELS: Record<TransferItemStatus, string> = {
  PENDING: 'Pendiente',
  PARTIALLY_LOADED: 'Cargada en parte',
  LOADED: 'Cargada',
  IN_TRANSIT: 'En ruta',
  PARTIALLY_DELIVERED: 'Entregada en parte',
  DELIVERED: 'Entregada',
  CANCELLED: 'Cancelada',
};

export const TRANSFER_ASSET_STATUS_LABELS: Record<TransferAssetStatus, string> = {
  PENDING: 'Pendiente',
  LOADED: 'Cargado',
  IN_TRANSIT: 'En ruta',
  DELIVERED: 'Entregado',
  CANCELLED: 'Cancelado',
};

/** Estados en los que la orden todavia se puede cancelar desde el panel. */
export const CANCELLABLE_STATUSES: OrderStatus[] = [
  'DRAFT',
  'ASSIGNED',
  'PENDING_PICKUP',
  'PICKUP_IN_PROGRESS',
];

export const INCIDENT_TYPE_LABELS: Record<IncidentType, string> = {
  DAMAGE: 'Material danado',
  MISSING: 'Material faltante',
  OTHER: 'Otro problema',
};

export const INCIDENT_STATUS_LABELS: Record<IncidentStatus, string> = {
  OPEN: 'Abierto',
  RESOLVED: 'Resuelto',
};

export const EVIDENCE_TYPE_LABELS: Record<EvidenceType, string> = {
  INVENTORY_ARRIVAL: 'Llegada al almacen',
  PICKUP: 'Carga',
  DELIVERY: 'Entrega',
  DAMAGE: 'Daño',
  RETURN: 'Devolución',
  OTHER: 'Otra',
};

export const SIGNATURE_TYPE_LABELS: Record<SignatureType, string> = {
  PICKUP: 'Firma de salida',
  DELIVERY: 'Firma de recepcion',
};
